module.exports = __webpack_public_path__ + "amcharts/images/dragIcon.gif";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIcon.gif
// module id = 226
// module chunks = 0